import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Single source of truth for the Admin › General Settings "WhatsApp Order Button" switch.
 * Returns `null` while loading, then true/false. Defaults to false on failure so the
 * ordering CTA is never shown by accident. Always re-fetched on mount (no stale cache).
 */
export default function useWhatsAppOrderEnabled() {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/settings/payment`)
      .then((r) => { if (alive) setEnabled(r.data?.whatsapp_enabled !== false); })
      .catch(() => { if (alive) setEnabled(false); });
    return () => { alive = false; };
  }, []);
  return enabled;
}
